__turbopack_context__.v({
  "notificationDrawer": "Inbox-module-scss-module__3fvE5W__notificationDrawer",
});
